import { render, staticRenderFns } from "./Campanhas.vue?vue&type=template&id=68e20264"
import script from "./Campanhas.vue?vue&type=script&lang=js"
export * from "./Campanhas.vue?vue&type=script&lang=js"
import style0 from "./Campanhas.vue?vue&type=style&index=0&id=68e20264&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports